.action {
  position: relative;
  padding: 0;
  border: 0;
  background: none;
  font: var(--text-footnote);
  color: var(--label-2);
  text-decoration: underline;
  text-decoration-color: color-mix(in srgb, currentColor 35%, transparent);
  text-underline-offset: 3px;
  white-space: nowrap;
  cursor: pointer;
}

.action:hover:not(:disabled, [aria-disabled="true"]) {
  color: var(--label);
  text-decoration-color: currentColor;
}

.action:disabled,
.action[aria-disabled="true"] {
  color: var(--label-3);
  text-decoration: none;
  cursor: default;
}

.row {
  font: var(--text-callout);
}

.inText {
  color: inherit;
  white-space: normal;
}

@media (pointer: coarse) {
  .action::after {
    content: "";
    position: absolute;
    inset: calc(-1 * var(--space-3)) calc(-1 * var(--space-2));
  }
}
